export default {
    PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA: 1,
    CONSULTA_RETORNO_ODONTOLOGIA: 2,
    CONSULTA_MANUTENCAO_ODONTOLOGIA: 3
}